import React, { useState } from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const Input: React.FC<InputProps> = ({
  label,
  id,
  type = "text",
  required,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(false);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    setHasValue(e.target.value !== "");
    props.onBlur?.(e);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    props.onFocus?.(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHasValue(e.target.value !== "");
    props.onChange?.(e);
  };

  const isActive = isFocused || hasValue;

  return (
    <div className="relative w-full mb-6 group">
      <input
        {...props}
        id={id}
        type={type}
        required={required}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder=" "
        className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-white/20 appearance-none focus:outline-none focus:ring-0 focus:border-accent peer transition-all duration-300 relative z-20"
      />
      <label
        htmlFor={id}
        className={`absolute text-sm text-white duration-300 transform top-3 z-10 origin-left pointer-events-none
          ${
            isActive
              ? "-translate-y-8 scale-90 text-accent font-semibold"
              : "translate-y-0 scale-100"
          } 
          peer-focus:text-accent peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0`}
      >
        {label} {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    </div>
  );
};

export default Input;
